import { render } from "./MDialogNotification.vue?vue&type=template&id=f60cd4b2&scoped=true"
import script from "./MDialogNotification.vue?vue&type=script&lang=js"
export * from "./MDialogNotification.vue?vue&type=script&lang=js"

import "./MDialogNotification.vue?vue&type=style&index=0&id=f60cd4b2&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60cd4b2"]])

export default __exports__